export default __webpack_public_path__ + "static/media/Tabl_18.24eb79ad.svg";